import { createSelector } from '@ngrx/store';

import { createSingleEntityStore } from '@core/ngrx-legacy';

import { CompanyVerificationRequest } from '../types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<CompanyVerificationRequest>()('spam-verification');

export const selectSpamVerificationStatus = createSelector(selectors.data, data => data?.status);

const SpamVerificationSelectors = {
  ...selectors,
  selectSpamVerificationStatus,
};

export {
  actions as SpamVerificationActions,
  SpamVerificationSelectors,
  reducer as SpamVerificationReducer,
  namespace as SpamVerificationNamespace,
};
